import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Element } from 'react-scroll'
import { TimelineItemTypes } from 'consts/timelineConsts'
import TimeBasedScanMarker from './TimeBasedScanMarker'
import MissedScanMarker from './MissedScanMarker'
import { MARKER_FOOTPRINT, SELECTED_MARKER_Z_INDEX } from './timeBasedLayout'

const useStyles = makeStyles(theme => ({
  marker: {
    position: 'absolute',
    left: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: MARKER_FOOTPRINT,
    height: MARKER_FOOTPRINT,
    transform: 'translate(-50%, -50%)',
    // The box is larger than the marker in it, so the boxes of two markers drawn close together
    // overlap. Only the marker answers the pointer, and z-index decides which of two overlapping
    // markers that is.
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'auto'
    }
  }
}))

/**
 * One item on the time axis, at the position the layout gave it.
 *
 * Markers that overlap are drawn newest in front - lower down the axis - so each one keeps a
 * crescent of its own to hover.
 */
const TimelineMarker = ({ item, offset, depth = 0, selectedTimelineItemId, onSelect, analyticsPayload = {} }) => {
  const classes = useStyles()

  return (
    // Below the month labels, which sit at a higher index: the band leaves only a couple of pixels
    // of clearance, so the label winning is a guarantee rather than a consequence of the geometry.
    <div
      className={classes.marker}
      // The selected scan is painted over every other marker, so a neighbour drawn after it never
      // clips its ring.
      style={{ top: offset, zIndex: item.id === selectedTimelineItemId ? SELECTED_MARKER_Z_INDEX : depth + 1 }}
    >
      <Element id={item.id} />
      {item.type === TimelineItemTypes.MissedScan ? (
        <MissedScanMarker timelineItem={item} />
      ) : (
        <TimeBasedScanMarker
          timelineItem={item}
          isSelected={item.id === selectedTimelineItemId}
          onSelect={section => onSelect({ timelineItem: item, section })}
          analyticsPayload={analyticsPayload}
        />
      )}
    </div>
  )
}

export default React.memo(TimelineMarker)
